'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface BankPartner {
  id: string;
  name: string;
  logo: string;
}

const BankPartnersSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const bankPartners: BankPartner[] = [
    { id: '1', name: 'PKO Bank Polski', logo: 'PKO' },
    { id: '2', name: 'mBank', logo: 'mBank' },
    { id: '3', name: 'ING Bank Śląski', logo: 'ING' },
    { id: '4', name: 'Santander Bank Polska', logo: 'Santander' },
    { id: '5', name: 'Bank Pekao', logo: 'Pekao' },
    { id: '6', name: 'Millennium Bank', logo: 'Millennium' },
    { id: '7', name: 'Alior Bank', logo: 'Alior' },
    { id: '8', name: 'Bank BNP Paribas', logo: 'BNP' },
    { id: '9', name: 'Credit Agricole', logo: 'CA' },
    { id: '10', name: 'Nest Bank', logo: 'Nest' },
  ];

  if (!isHydrated) {
    return (
      <section className="py-16 lg:py-24 bg-muted/30">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl lg:text-3xl font-headline font-bold text-foreground mb-4">
              Współpracujemy z wiodącymi bankami
            </h2>
          </div>
          <div className="grid grid-cols-3 md:grid-cols-5 gap-6">
            {[1, 2, 3, 4, 5].map(i => (
              <div key={i} className="bg-card rounded-lg h-24 animate-pulse" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
            <Icon name="BuildingLibraryIcon" size={20} variant="solid" className="text-primary" />
            <span className="text-sm font-body font-medium text-primary">
              Partnerzy
            </span>
          </div>

          <h2 className="text-2xl lg:text-3xl font-headline font-bold text-foreground mb-4">
            Współpracujemy z 20+ wiodącymi bankami
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto">
            Dzięki szerokiej sieci partnerów bankowych możemy zagwarantować najlepsze warunki finansowania
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {bankPartners.map(bank => (
            <div
              key={bank.id}
              className="bg-card rounded-lg shadow-card p-6 flex items-center justify-center transition-all duration-250 hover:shadow-lg hover:scale-105"
            >
              <div className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-xl font-headline font-bold text-primary">
                    {bank.logo}
                  </span>
                </div>
                <p className="text-xs font-body font-medium text-foreground">
                  {bank.name}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-card rounded-xl shadow-card p-8 text-center">
          <Icon name="ShieldCheckIcon" size={48} variant="solid" className="text-success mx-auto mb-4" />
          <h3 className="text-xl font-headline font-bold text-foreground mb-2">
            Gwarancja najlepszych warunków
          </h3>
          <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
            Dzięki współpracy z wieloma bankami porównujemy oferty i negocjujemy warunki, aby zapewnić Ci najkorzystniejsze finansowanie na rynku
          </p>
        </div>
      </div>
    </section>
  );
};

export default BankPartnersSection;